export default {
  LANDING: "landing page",
  LISTING: "listing page",
};
